module.exports = __webpack_public_path__ + "img/HC1031-76.35cff153.jpg";